"use client";

import { c as _c } from "react/compiler-runtime";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useRouter, useSearchParams } from "next/navigation";
import useDeviceInfo from "@/hooks/useDeviceInfo";
import { getWaveHomeRoute, getWaveRoute } from "@/helpers/navigation.helpers";
const getWaveFromWindow = (): string | null => {
  if (globalThis.window === undefined) return null;
  const url = new URL(globalThis.window.location.href);
  const wave = url.searchParams.get("wave");
  return typeof wave === "string" ? wave : null;
};
const getRouteContext = (): {
  isOnWaves: boolean;
  isOnMessages: boolean;
} => {
  if (globalThis.window === undefined) {
    return {
      isOnWaves: false,
      isOnMessages: false
    };
  }
  const pathname = globalThis.window.location.pathname;
  return {
    isOnWaves: pathname === "/waves" || pathname.startsWith("/waves/"),
    isOnMessages: pathname === "/messages" || pathname.startsWith("/messages/")
  };
};
export function useActiveWaveManager() {
  const $ = _c(13);
  const router = useRouter();
  const searchParams = useSearchParams();
  const {
    isApp
  } = useDeviceInfo();
  let t0;
  if ($[0] !== searchParams) {
    t0 = searchParams?.get("wave");
    $[0] = searchParams;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const waveId = t0;
  const waveFromSearchParams = typeof waveId === "string" ? waveId : null;
  const [activeWaveId, setActiveWaveId] = useState(waveFromSearchParams);
  let t1;
  let t2;
  if ($[2] !== waveFromSearchParams) {
    t1 = () => {
      setActiveWaveId(waveFromSearchParams);
    };
    t2 = [waveFromSearchParams];
    $[2] = waveFromSearchParams;
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  useEffect(t1, t2);
  let t3;
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      if (globalThis.window === undefined) {
        return;
      }
      const {
        window: browserWindow
      } = globalThis;
      if (!browserWindow) {
        return;
      }
      const onPopState = () => {
        setActiveWaveId(getWaveFromWindow());
      };
      browserWindow.addEventListener("popstate", onPopState);
      return () => browserWindow.removeEventListener("popstate", onPopState);
    };
    t4 = [];
    $[5] = t3;
    $[6] = t4;
  } else {
    t3 = $[5];
    t4 = $[6];
  }
  useEffect(t3, t4);
  let t5;
  if ($[7] !== isApp || $[8] !== router) {
    t5 = (waveId_0, options) => {
      if (globalThis.window === undefined) {
        return;
      }
      const {
        window: browserWindow_0
      } = globalThis;
      if (!browserWindow_0) {
        return;
      }
      const isDirectMessage = options?.isDirectMessage ?? false;
      const target = waveId_0 ? getWaveRoute({
        waveId: waveId_0,
        isDirectMessage,
        isApp
      }) : getWaveHomeRoute({
        isDirectMessage,
        isApp
      });
      const currentUrl = browserWindow_0.location.pathname + browserWindow_0.location.search;
      if (currentUrl === target) {
        setActiveWaveId(waveId_0);
        return;
      }
      const {
        isOnWaves,
        isOnMessages
      } = getRouteContext();
      const canUsePushState = !isDirectMessage && isOnWaves || isDirectMessage && isOnMessages;
      if (canUsePushState) {
        const method = options?.replace ? "replaceState" : "pushState";
        browserWindow_0.history[method](null, "", target);
        setActiveWaveId(waveId_0);
      } else {
        if (options?.replace) {
          router.replace(target);
        } else {
          router.push(target);
        }
      }
    };
    $[7] = isApp;
    $[8] = router;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const setActiveWave = t5;
  let t6;
  if ($[10] !== activeWaveId || $[11] !== setActiveWave) {
    t6 = {
      activeWaveId,
      setActiveWave
    };
    $[10] = activeWaveId;
    $[11] = setActiveWave;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
}